export default "__VITE_ASSET__D1uTRf$7__"